// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1dybA","requiredAsterisk":"Info_requiredAsterisk__9DYMb"};